export const rehab = {
  landmarks: [
    "بوابات مدينة الرحاب",
    "السوق الشرقي",
    "السوق القديم",
    "طريق السويس",
    "محور السادات",
    "مول أفينيو",
    "نادي الرحاب",
    "بوابة 13 الرحاب"
  ],
  title: "ونش انقاذ الرحاب | استجابة فورية داخل مدينة الرحاب وطريق السويس",
  metaDescription: "تعطلت سيارتك في مدينة الرحاب؟ نقدم خدمة ونش انقاذ راقية وموثوقة لسحب السيارات من السوق الشرقي، محور السادات وطريق السويس بأحدث الأوناش المسطحة.",
  intro: `مدينة الرحاب تمثل نموذجاً للمدن السكنية الراقية والمنظمة في القاهرة الجديدة، وتتميز بشوارعها الهادئة ومناطقها التجارية الحيوية مثل السوق الشرقي والسوق القديم، فضلاً عن موقعها الممتاز على طريق السويس ومحور السادات. في حالة تعرض سيارتك لأي طارئ داخل الرحاب أو على حدودها، فإنك تستحق خدمة ونش انقاذ تعكس نفس مستوى الرقي والنظام.
  نحن نوفر خدمة ونش انقاذ الرحاب على مدار الساعة. نضمن لك وصولاً سريعاً من خلال بوابات المدينة المتعددة بفضل تصاريحنا المسبقة وخبرتنا في تضاريس وشوارع الرحاب. أسطولنا يضم أوناشاً هيدروليكية مصممة لرفع السيارات بعناية فائقة، لنوفر لك الطمأنينة الكاملة والحل الأسرع لسيارتك.`,
  highlights: [
    "إمكانية الدخول السريع عبر بوابات الرحاب لإنقاذ السيارات من أمام المنازل والأسواق",
    "تغطية فورية لمحور السادات وطريق السويس لسرعة تأمين سيارتك",
    "أوناش مسطحة توفر أعلى حماية للسيارات الفارهة والأوتوماتيك",
    "فريق دعم متاح 24/7 للتعامل مع أي عطل في أوقات متأخرة بكل احترافية"
  ],
  safetyTips: [
    "إذا تعطلت بالقرب من السوق الشرقي المزدحم، حاول إيقاف السيارة في أقرب منطقة انتظار للسيارات لعدم تعطيل حركة المرور.",
    "على طريق السويس أو محور السادات، تأكد من استخدام الإشارات التحذيرية والوقوف في أقصى اليمين للحفاظ على سلامتك.",
    "عند الاتصال بنا، حدد رقم البوابة الأقرب إليك (مثل بوابة 13 أو بوابة 1) لنوجه سائق الونش للوصول إليك بأقصر طريق ممكن."
  ],
  faqs: [
    {
      q: "هل يمكن لونش الإنقاذ سحب سيارتي من داخل الفيلا الخاصة بي في الرحاب؟",
      a: "نعم، أوناشنا يمكنها الوصول إلى عنوانك المحدد داخل مدينة الرحاب والتعامل مع سحب السيارة بأمان تام بفضل تجهيزاتنا المناسبة لذلك."
    },
    {
      q: "نسيت أضواء السيارة مضاءة والبطارية فارغة تماماً، هل يمكنكم المساعدة؟",
      a: "بالتأكيد، نوفر خدمة شحن البطاريات الفوري (Jump Start) لإعادة تشغيل سيارتك في مكانها دون الحاجة لرفعها ونقلها."
    },
    {
      q: "كم يستغرق الوقت لوصول الونش إذا كنت أمام نادي الرحاب؟",
      a: "نحن نوزع سياراتنا بشكل استراتيجي في القاهرة الجديدة، لذا فإن الوقت المستغرق للوصول لأي مكان داخل الرحاب يتراوح بين 10 إلى 15 دقيقة فقط."
    },
    {
      q: "سيارتي ذات دفع رباعي وتوقفت تماماً، هل السحب آمن لها؟",
      a: "نعم، نستخدم أوناش السطحة التي ترفع سيارات الدفع الرباعي بالكامل عن الأرض، وهي الطريقة الوحيدة الآمنة الموصى بها لتجنب تلف ناقل الحركة والكرونة."
    }
  ],
  seoText: `
    <h2>أفضل خدمة طوارئ وونش انقاذ في مدينة الرحاب</h2>
    <p>مدينة الرحاب من أولى وأهم المدن الجديدة التي تستقطب الكثير من الزوار بفضل أسواقها التجارية الكبيرة ونادي الرحاب. ولأن راحة سكان الرحاب وزوارها تهمنا، وفرنا خدمة ونش انقاذ الرحاب المتخصصة في التعامل السريع والآمن مع كافة أنواع الطوارئ المرورية. سواء كان عطلاً بسيطاً أو حاجة لنقل السيارة لمركز صيانة، نحن هنا لتقديم المساعدة المطلوبة في وقت قياسي.</p>

    <h3>حماية فائقة لسيارتك أثناء السحب</h3>
    <p>نعلم أن الحفاظ على سيارتك من الخدوش أو الأضرار الميكانيكية هو أولويتك. لذا، فإن فريقنا مدرب بشكل مكثف على استخدام أحدث أوناش الرفع المسطحة. نستخدم أحزمة ربط مخصصة للإطارات لضمان عدم وجود أي ضغط على الهيكل أو العفشة أثناء رفع وإنزال السيارة، لنوفر لك خدمة خالية من العيوب تماماً.</p>

    <h3>شبكة تغطية قوية في القاهرة الجديدة</h3>
    <p>موقع الرحاب الحيوي يربطها بالعديد من المناطق في القاهرة الجديدة. ولأننا نغطي المنطقة بالكامل، فإن دعمنا يمتد ليشمل محيطك. إذا كنت بالقرب من التجمع الأول، فإن <a href="/areas/التجمع الأول">ونش انقاذ التجمع الأول</a> جاهز لمساعدتك، وإذا واصلت طريقك نحو طريق السويس، ستجد زملاءنا في <a href="/areas/مدينتي">ونش انقاذ مدينتي</a> على مقربة منك. نحن نعمل كفريق واحد لضمان سلامتك على مدار الساعة أينما كنت.</p>
    <p>لأي طارئ يواجه سيارتك في الرحاب، نحن على بُعد مكالمة واحدة فقط لتوفير أفضل وأسرع مساعدة.</p>
  `
};
